module.exports = __webpack_public_path__ + "img/libya.13bccc1e.png";